import React from "react";

function Contact() {
  return (
    <>
      <section className="bg-light" id="contact">
        <div className="container">
          <header className="mb-5 pb-4" style={{ textAlign: "center" }}>
            <p className="font-weight-bold text-primary text-uppercase letter-spacing-3">
              Call me, maybe.
            </p>
            <h2 className="text-uppercase lined">Contact</h2>
          </header>
          <div className="row">
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="px-4 py-5 text-center contact-item shadow-sm">
                <i className="fas fa-map-marker-alt fa-2x mb-4" />
                <h4 className="contact-item-title h5 text-uppercase">
                  Location
                </h4>
                <p className="text-small mb-0">Lagos, Nigeria</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <div className="px-4 py-5 text-center contact-item shadow-sm">
                <i className="fas fa-mobile fa-2x mb-4" />
                <h4 className="contact-item-title h5 text-uppercase">Phone</h4>
                <p className="text-small mb-0">+2348022858870</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <a
                className="px-4 py-5 text-center contact-item shadow-sm d-block reset-anchor"
                href="https://github.com/production-app/"
              >
                <i className="fab fa-github fa-2x mb-4" />

                <h4 className="contact-item-title h5 text-uppercase">
                  Website
                </h4>
                <p className="text-small mb-0">wwww.github.com</p>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
              <a
                className="px-4 py-5 text-center contact-item shadow-sm d-block reset-anchor"
                href="mailto:info@example.com"
              >
                <i className="fas fa-envelope fa-2x mb-4" />
                <h4 className="contact-item-title h5 text-uppercase">Email</h4>
                <p className="text-small mb-0">developerbiodun@gmail.com</p>
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
